import { DEFAULT_PRIME_AGE_RANGE } from "./planCreation.constants";
export var INITIAL_PLAN_FORM = {
    Name: "",
    Code: "",
};
export var EMPTY_BENEFIT_FORM = {};
export var INITIAL_PRIME_FORM = {
    Age: DEFAULT_PRIME_AGE_RANGE,
};
